module.exports = __webpack_public_path__ + "static/scale-model-of-hollywood-walk-of-fame-in-glendale-california-7c5905f6da7c6605c366609d44ca4ed0.png";